jQuery(document).ready(function($) {
  /*----- utils -----*/
  const isMobile = () => {
    return $(window).width() <= 800;
  };


  /*----- accordion -----*/
  const $comparisonPage = document.querySelector('.comparison-page');
  const $accordionHeader = $('.accordion-header');
  const $accordionHeaderInit = $(".accordion-header").attr('init-accordion');

  function showAccordion(event) {
    event.preventDefault();

    if ($(event.currentTarget).hasClass('active')) {
      $(event.currentTarget).removeClass('active')
        .find('.accordion-btn').removeClass('active');

      $(event.currentTarget).next()
        .removeClass('active')
        .stop()
        .slideUp(300);
    } else {
      $(event.currentTarget).addClass('active')
        .find('.accordion-btn').addClass('active');

      $(event.currentTarget).next()
        .addClass('active')
        .stop()
        .slideDown(300);
    }
  };

  if (isMobile() && !$comparisonPage) {
    if ($accordionHeaderInit != 'true') {
      $accordionHeader.addClass('show-accordion').attr('init-accordion', "true");
      $('.accordion-header--desktop').off('click', showAccordion);
      $accordionHeader.on('click', showAccordion);
    }
  } else {
    if ($accordionHeaderInit == 'true') {
      $accordionHeader.removeClass('show-accordion active').attr('init-accordion', "false")
        .find('.accordion-btn').removeClass('active');
      $accordionHeader.next().removeClass('active');
      $accordionHeader.off('click', showAccordion);
    }

    $('.accordion-header--desktop').on('click', showAccordion);
  }


  /*----- mobile extended block -----*/
  function toggleExtendedBlockFunc() {
    const $parentBlock = $('.extended-block');
    const $showMoreButton = $parentBlock.find('.show-btn');
    const $showLessButton = $parentBlock.find('.hide-btn');
    const $hiddenPart = $parentBlock.find('.hidden-part');

    if (isMobile()) {
      $parentBlock.attr('init-device', 'mobile');

      $showMoreButton.on('click', function(event) {
        event.preventDefault();

        $(event.currentTarget).addClass('hidden');
        $(event.currentTarget).closest($parentBlock).find($hiddenPart).show();
        $(event.currentTarget).closest($parentBlock).find($showLessButton).removeClass('hidden');
      });

      $showLessButton.on('click', function(event) {
        event.preventDefault();

        $(event.currentTarget).addClass('hidden');
        $(event.currentTarget).closest($parentBlock).find($hiddenPart).hide();
        $(event.currentTarget).closest($parentBlock).find($showMoreButton).removeClass('hidden');
      });
    } else {
      $parentBlock.attr('init-device', 'desktop');
      $hiddenPart.show();
    }
  }

  $(window).on('onload resize orientationchange', function() {
    isMobile();
    toggleExtendedBlockFunc();
  });
});